import React from "react";
import { Row, Col } from 'reactstrap';

import CheckListProcessForm from '../../../check_list/process/form';

import { create, update } from './axios';

const LaboralCheckListHiringProcessForm = props => {
  const {
    checkListProcess,
    currentCustomer,
    currentUser,
    data
  } = props;

  return(
    <Row>
      <Col md={12}>
        <CheckListProcessForm
          checkListProcess={ checkListProcess }
          currentCustomer={ currentCustomer }
          currentUser={ currentUser }
          data={ data }
          configuration={{
            context: "laboral",
            defaultRequestParams: {},
          }}
          services={{
            createService: create,
            updateService: update,
          }}
          routes={{
            showPath: Routes.laboral_check_list_hiring_process_path,
            indexPath: Routes.laboral_check_list_hiring_processes_path()
          }}
        />
      </Col>
    </Row>
  )
};

export default LaboralCheckListHiringProcessForm;
